module.exports = __webpack_public_path__ + "static/img/pro3.b90f0ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productimg/pro3.png
// module id = k9fx
// module chunks = 0